import { HttpClient } from '#client/http/index'
import { bindMethods } from '#client/utils/bindMethods'
import { Methods } from '#utils/typeUtils'
import { SegmentedClientInterface } from '../SegmentedClientInterface'
import * as activities from './activities/methods'
import * as areas from './areas/methods'
import * as campaignBanners from './campaignBanners/methods'
import * as campaigns from './campaigns/methods'
import * as contacts from './contacts/methods'
import * as facilities from './facilities/methods'
import * as favorites from './favorites/methods'
import * as grades from './grades/methods'
import * as inquiries from './inquiries/methods'
import * as me from './me/methods'
import * as notifications from './notifications/methods'
import * as payments from './payments/methods'
import * as points from './points/methods'
import * as pointSubscriptions from './pointSubscriptions/methods'
import * as prefectures from './prefectures/methods'
import * as profiles from './profiles/methods'
import * as programs from './programs/methods'
import * as rankings from './rankings/methods'
import * as referrals from './referrals/methods'
import * as reservationRequests from './reservationRequests/methods'
import * as reservations from './reservations/methods'
import * as reviews from './reviews/methods'
import * as serviceForCorporations from './serviceForCorporations/methods'
import * as sitemap from './sitemap/methods'
import * as tags from './tags/methods'
import * as timetables from './timetables/methods'
import * as top from './top/methods'

export class UserClient implements SegmentedClientInterface {
  #activities: Methods<typeof activities>
  #areas: Methods<typeof areas>
  #campaignBanners: Methods<typeof campaignBanners>
  #campaigns: Methods<typeof campaigns>
  #contacts: Methods<typeof contacts>
  #facilities: Methods<typeof facilities>
  #favorites: Methods<typeof favorites>
  #grades: Methods<typeof grades>
  #inquiries: Methods<typeof inquiries>
  #me: Methods<typeof me>
  #notifications: Methods<typeof notifications>
  #payments: Methods<typeof payments>
  #points: Methods<typeof points>
  #pointSubscriptions: Methods<typeof pointSubscriptions>
  #prefectures: Methods<typeof prefectures>
  #profiles: Methods<typeof profiles>
  #programs: Methods<typeof programs>
  #rankings: Methods<typeof rankings>
  #referrals: Methods<typeof referrals>
  #reservationRequests: Methods<typeof reservationRequests>
  #reservations: Methods<typeof reservations>
  #reviews: Methods<typeof reviews>
  #serviceForCorporations: Methods<typeof serviceForCorporations>
  #sitemap: Methods<typeof sitemap>
  #tags: Methods<typeof tags>
  #timetables: Methods<typeof timetables>
  #top: Methods<typeof top>

  constructor(httpClient: HttpClient) {
    this.#activities = bindMethods(this, { httpClient }, { activities })
    this.#areas = bindMethods(this, { httpClient }, { areas })
    this.#campaignBanners = bindMethods(
      this,
      { httpClient },
      { campaignBanners },
    )
    this.#campaigns = bindMethods(this, { httpClient }, { campaigns })
    this.#contacts = bindMethods(this, { httpClient }, { contacts })
    this.#facilities = bindMethods(this, { httpClient }, { facilities })
    this.#favorites = bindMethods(this, { httpClient }, { favorites })
    this.#grades = bindMethods(this, { httpClient }, { grades })
    this.#inquiries = bindMethods(this, { httpClient }, { inquiries })
    this.#me = bindMethods(this, { httpClient }, { me })
    this.#notifications = bindMethods(this, { httpClient }, { notifications })
    this.#payments = bindMethods(this, { httpClient }, { payments })
    this.#points = bindMethods(this, { httpClient }, { points })
    this.#pointSubscriptions = bindMethods(
      this,
      { httpClient },
      { pointSubscriptions },
    )
    this.#prefectures = bindMethods(this, { httpClient }, { prefectures })
    this.#profiles = bindMethods(this, { httpClient }, { profiles })
    this.#programs = bindMethods(this, { httpClient }, { programs })
    this.#rankings = bindMethods(this, { httpClient }, { rankings })
    this.#referrals = bindMethods(this, { httpClient }, { referrals })
    this.#reservationRequests = bindMethods(
      this,
      { httpClient },
      { reservationRequests },
    )
    this.#reservations = bindMethods(this, { httpClient }, { reservations })
    this.#reviews = bindMethods(this, { httpClient }, { reviews })
    this.#serviceForCorporations = bindMethods(
      this,
      { httpClient },
      { serviceForCorporations },
    )
    this.#sitemap = bindMethods(this, { httpClient }, { sitemap })
    this.#tags = bindMethods(this, { httpClient }, { tags })
    this.#timetables = bindMethods(this, { httpClient }, { timetables })
    this.#top = bindMethods(this, { httpClient }, { top })
  }

  get prefix() {
    return 'user'
  }

  get activities() {
    return this.#activities
  }

  get areas() {
    return this.#areas
  }

  get campaignBanners() {
    return this.#campaignBanners
  }

  get campaigns() {
    return this.#campaigns
  }

  get contacts() {
    return this.#contacts
  }

  get facilities() {
    return this.#facilities
  }

  get favorites() {
    return this.#favorites
  }

  get grades() {
    return this.#grades
  }

  get inquiries() {
    return this.#inquiries
  }
  get me() {
    return this.#me
  }

  get notifications() {
    return this.#notifications
  }

  get payments() {
    return this.#payments
  }

  get points() {
    return this.#points
  }

  get pointSubscriptions() {
    return this.#pointSubscriptions
  }

  get prefectures() {
    return this.#prefectures
  }

  get profiles() {
    return this.#profiles
  }

  get programs() {
    return this.#programs
  }

  get rankings() {
    return this.#rankings
  }

  get referrals() {
    return this.#referrals
  }

  get reservationRequests() {
    return this.#reservationRequests
  }

  get reservations() {
    return this.#reservations
  }

  get reviews() {
    return this.#reviews
  }

  get serviceForCorporations() {
    return this.#serviceForCorporations
  }

  get sitemap() {
    return this.#sitemap
  }

  get tags() {
    return this.#tags
  }

  get timetables() {
    return this.#timetables
  }

  get top() {
    return this.#top
  }
}
